import * as React from "react";
import { Header } from "../Header";
import { WebDate } from "../../../../WebDate";
import * as screen1 from "./style.module.scss";
export const Screen1 = ({ id, widgetFree, widgetPrice, isGiftBlock, isExtraInfo, sravni }) => {
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <Header noLink={sravni}/>
        <div className={screen1.wrap}>
          <div className={screen1.info}>
            <div className={screen1.inner}>
              <p className={screen1.type}>Бесплатный 5-дневный марафон</p>
              <time><WebDate id={id} dateText={' (Москва)'}/></time>
            </div>
            <h1>Марафон <span>мотивации и&nbsp;обучения</span>&nbsp;детей</h1>
            <p className={screen1.sub}>Ребенок научится <span>самостоятельно</span> выполнять домашние задания</p>
            <div className={screen1.reg}>
              <div className={screen1.form}>
                <h3>Заполните поля и получите доступ к марафону:</h3>
                { widgetFree }
              </div>
            </div>
            {
              isGiftBlock &&
              <p className={screen1.giftBlock}>Запишитесь и получите набор<br/> для успешного школьного обучения</p>
            }
          </div>
          <div className={screen1.img}>
            <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/rus/screen1.png" alt=""/>
          </div>
        </div>
      </div>
      {
        isExtraInfo &&
        <div className={screen1.extraInfo}>
          <div className="container">
            <p>Бесплатный доступ к марафону</p>
            <p>Начало <WebDate id={id} dateText={' (Москва)'}/></p>
          </div>
        </div>
      }
    </section>
  );
};
